"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importStar(require("react"));
const Tabs_styled_1 = require("./Tabs.styled");
const WrapperWithEdgeGradients_1 = require("../WrapperWithEdgeGradients/WrapperWithEdgeGradients");
const Tabs = ({ items, selectedTab, onSelect, disabled, children, }) => {
    const [dotPosition, setDotPosition] = (0, react_1.useState)(null);
    const [greyOutDot, setGreyOutDot] = (0, react_1.useState)(false);
    const scrollElementRef = (0, react_1.useRef)(null);
    const selectedElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const scrollElement = scrollElementRef.current;
        const selectedElement = selectedElementRef.current;
        if (scrollElement && selectedElement) {
            scrollElement.scrollTo({
                left: selectedElement.offsetLeft + selectedElement.offsetWidth / 2 - scrollElement.offsetWidth / 2,
                behavior: 'smooth',
            });
            setDotPosition(selectedElement.offsetLeft + selectedElement.offsetWidth / 2);
        }
    }, [selectedTab]);
    return (react_1.default.createElement(WrapperWithEdgeGradients_1.WrapperWithEdgeGradients, { ref: scrollElementRef, gap: "20px" },
        items.map((item, index) => {
            const value = typeof item === 'string' ? item : item.value;
            const label = typeof item === 'string' ? item : item.label;
            const isSelected = value === selectedTab;
            return (react_1.default.createElement(Tabs_styled_1.TabItemStyled, { ref: (element) => {
                    if (isSelected && element) {
                        selectedElementRef.current = element;
                    }
                }, disabled: disabled, onMouseOver: () => {
                    if (isSelected) {
                        setGreyOutDot(true);
                    }
                }, onMouseLeave: () => {
                    if (isSelected) {
                        setGreyOutDot(false);
                    }
                }, canGreyout: greyOutDot, key: index, isSelected: isSelected, onClick: () => {
                    if (onSelect) {
                        onSelect(value);
                    }
                } }, label));
        }),
        children && react_1.default.createElement("div", { className: "mr-16" }, children),
        selectedTab && dotPosition !== null && (react_1.default.createElement(Tabs_styled_1.DotStyled, { position: dotPosition, disabled: disabled || greyOutDot }))));
};
exports.Tabs = Tabs;
